import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedWarehouseVehicleSetup } from 'contracts/WarehouseVehicleSetups';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_WAREHOUSE_VEHICLE_SETUPS_',
  }
);

export interface ListWarehouseVehicleSetupsState {
  data: ListedWarehouseVehicleSetup[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListWarehouseVehicleSetupsRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ListedWarehouseVehicleSetup[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListWarehouseVehicleSetupsState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListWarehouseVehicleSetupsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (
  state: ListWarehouseVehicleSetupsState,
  action: SuccessAction
) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (
  state: ListWarehouseVehicleSetupsState,
  action: FailureAction
) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListWarehouseVehicleSetupsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listWarehouseVehicleSetups = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListWarehouseVehicleSetupsTypes = Types;
export const ListWarehouseVehicleSetupsActions = Creators;
